

<div class="max-page-width">

  <div class="container-fluid search-icons">
    <div class="row">
      <div class="col-md-7"></div>
      <div id="google-map-icon" class="col-md-5 locaion-list-icons" >
        <div class="google-map-icon text-right">
          <input onclick="showandclose()" type="image" src="assets/img/googleMapIcon.svg" alt="Submit" width="48" height="48">
        </div>
      </div>
    </div>
  </div>

  <div class="container-list" >
    <article>
      <div class="row p-0 m-0">
        <div id="locationList" class="col-md-11 pt-3 location-list">

          <div id="main" *ngIf="branches!=null && branches.length > 0">
            <div id="search-results" infiniteScroll [infiniteScrollDistance]="5" [infiniteScrollThrottle]="30" [scrollWindow]="true"  (scrolled)="onScroll()" *ngFor="let branch of branches" >
              <div id="branch-{{branch.id}}" class="searchCardLocation wow fadeInUp animated" (mouseover)="mouseover(branch)" (mouseout)="mouseout(branch)" [ngClass]="branch.isHovered ? 'active' : 'notActive'" >
                <div class="row">
                  <div class="col-md-5 col-12 d-flex flex-row align-items-center border-right">
                      <div class="anchor-icon mr-3"><fa-icon [icon]="faBullseye"  ></fa-icon></div>
                      <div class="branch-name">
                        <div>{{branch.name | translate}}</div>

                        <div class="text-black">{{ branch.locationName}}</div>

                        <a class="text-muted pointer" (click)="onShowMapClicked(branch)" >
                          <small>
                            <u>{{ 'ShowOnMap' | translate }}</u>
                        </small></a>

                      </div>
                  </div>
                  <div class="col-md-4 col-12 d-flex align-items-center border-right justify-content-center search-mobile-section">
                    <div class="branch-price">
                      {{ 'StartingFrom' | translate }}
                      <p class="price mb-0">{{branch.price | number}} {{currency}}</p>
                      <span>{{ 'PriceFor' | translate }}  {{branch.durationUnitName}} </span>
                    </div>
                  </div>
                  <div class="col-md-3 col-12 d-flex justify-content-center align-items-center">
                    <div class="show-all-cars d-flex"><a (click)="onShowAllCarsClicked(branch)" > <span class="showAll">{{ 'showAll' | translate }}</span> <br /> {{branch.totalCars}} {{ 'cars' | translate }}</a></div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <ng-container  *ngIf="branches!=null && branches.length == 0">
          
              <div class="row">
                <div class="col-md-12 mt-5  d-flex flex-column justify-content-center align-items-center">
                  <div class="no-available-image">
                    <!-- <mat-icon svgIcon="noAvailableRental"></mat-icon>  -->
                    <img src='assets/img/icons/car-noavailable.svg' />
                  </div>
                  <div class="no-available-text">
                    <p>{{ 'Sorry!NoAvailableRentalsThatMatchYourSearchCriteria' | translate }}</p>
                  </div>
                  <div class="no-available-btn">
                    <a href="/" class="light-blue text-bold">{{ 'TryOtherCriteria' | translate }}</a>
                  </div>
                </div>
              </div>
            
          </ng-container>


        </div>
        <aside id="gooleMap" style="display: none;" class="col-md-4 p-0">
          <div id="sticky-sidebar-stuff">
            <div class="google-map ">
            <googlemappage></googlemappage>
            </div>
          </div>
        </aside>
      </div>
    </article>

  </div>

</div>



